<template>
  <div class="el-choices">
    <div class="el-choices__head">
      <div class="cp-field cp-field--mode">
        <label class="cp-label">{{ L.choiceMode || 'Selection' }}</label>
        <CustomSelect :value="element.type" :options="modeOptions" @input="$emit('change-type', $event)" />
      </div>
      <CustomSwitch class="el-req" :value="element.required" :label="L.required || 'Required'" @input="element.required = $event" />
    </div>

    <label class="cp-label cp-label--mt">{{ L.questionOptions || 'Choices' }}</label>
    <OptionRow
        v-for="(opt, i) in element.options"
        :key="opt.uid || i"
        :options="options"
        :option="opt"
        :lang="lang"
        @remove="$emit('remove-option', i)" />
    <p v-if="!element.options.length" class="cp-empty">{{ L.noChoices || 'No choices yet.' }}</p>
    <md-button class="md-raised cp-add" @click="$emit('add-option')">
      <md-icon>add</md-icon>{{ L.addOption || 'Add option' }}
    </md-button>
  </div>
</template>

<script>
import CustomSelect from '../../../../parts/CustomSelect.vue'
import CustomSwitch from '../../../../parts/CustomSwitch.vue'
import OptionRow from '../OptionRow.vue'

/**
 * 'single' / 'multiple' choice element: a set of options, single-pick (radios) or
 * multi-pick (checkboxes). The selection mode IS the element type — switching it
 * emits change-type so the parent flips the element's type. Add/remove options are
 * owned by the parent (array structure).
 */
export default {
  name: 'ElChoices',
  components: { CustomSelect, CustomSwitch, OptionRow },
  props: {
    options: { type: Object, required: true },
    element: { type: Object, required: true },
    lang: { type: String, default: 'de' }
  },
  computed: {
    L() { return this.options.Lang || {}; },
    modeOptions() {
      const L = this.L;
      return [
        { value: 'single', label: L.choiceSingle || 'Single choice (one answer)' },
        { value: 'multiple', label: L.choiceMultiple || 'Multiple choice (many answers)' }
      ];
    }
  }
};
</script>

<style scoped>
.el-choices { width: 100%; }
.el-choices__head { display: flex; align-items: flex-end; gap: 1.25rem; flex-wrap: wrap; margin-bottom: 0.85rem; }
.cp-field { display: flex; flex-direction: column; min-width: 0; }
.cp-field--mode { width: 280px; }
.el-req { margin-bottom: 0.5rem; }
.cp-label { display: block; font-size: 0.78rem; font-weight: 600; color: #555; margin-bottom: 0.5rem; }
.cp-label--mt { margin-top: 0.25rem; }
.cp-empty { font-style: italic; color: #999; margin: 0.25rem 0 0.6rem; font-size: 0.85rem; }
.cp-add { margin-top: 0.25rem; }
</style>
